module.exports = __webpack_public_path__ + "static/img/third-DVFjfGNx.b42ab3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/third-DVFjfGNx.png
// module id = I2bV
// module chunks = 16